import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <div className="cool-typewriter">
      <Typewriter
        options={{
          strings: [
            "Mobile App Developer",
            "Flutter & Android Dev",
            "Problem Solver",
            "App Architect",
          ],
          autoStart: true,
          loop: true,
          deleteSpeed: 30,
          delay: 60,
          cursor: " |",
        }}
      />
    </div>
  );
}

export default Type;
